/*==========================================================

    imgPolyfill.js - v1.0

    IMAGE POLYFILLS FOR IE
    Applies background-size: cover; effect for IE / MS Edge

    Parameters:
    xPos = left, center, right
    yPos = top, center, bottom
    
    Example:
    $(".imgContainer").imgPolyfill({
        xPos: "left",
        yPos: "top"
    });

    Or if you just want everything centered:
    $(".imgContainer").imgPolyfill();

==========================================================*/

(function($){
    $.fn.imgPolyfill = function(params){

        // Don't execute polyfill if the image doesn't exist in DOM
        // OR if objectFit is already supported by the browser
        if ($(this).find("img").length < 1 || ("objectFit" in document.documentElement.style === true)){
            return false;
        }

        // Set default parameters if none are defined
        if (params === undefined){
            var params = {};
            params["xPos"] = "center";
            params["yPos"] = "center";
        }

        // Make sure proper container styles are applied to use the polyfill
        var imageContainer = $(this);
        imageContainer.css({
            "position": "relative",
            "overflow": "hidden"
        });

        var imageSelector = imageContainer.find("img");
        imageSelector.css("position", "absolute");
        var theImage = document.querySelector(imageContainer.selector + " img");
        var imageWidthOriginal = theImage.naturalWidth;
        var imageHeightOriginal = theImage.naturalHeight;
        var imageRatio = imageWidthOriginal / imageHeightOriginal;
        var containerWidth = imageContainer.outerWidth(false);
        var containerHeight = imageContainer.outerHeight(false);
        var containerVertCenter;
        var newWidth = containerHeight * imageRatio;
        var newHeight;
        var containerHorCenter = containerWidth / 2;
        var imageHorCenter = newWidth / 2;
        var imageVertCenter;
        var topOffset;
        var leftOffset = (imageHorCenter - containerHorCenter) * -1;
    
        if (leftOffset <= 0){
            
            // Grow it taller
            imageSelector.css({
                "width" : Math.round(newWidth) + "px",
                "height" : "100%",
                "top" : "0",
                "bottom" : "auto"
            });
            
            // Check which horizontal side should be anchored (left, center, right)
            if (params["xPos"] == "left"){
                imageSelector.css({
                    "left" : "0",
                    "right" : "auto"
                });
            } else if (params["xPos"] == "right"){
                imageSelector.css({
                    "left" : "auto",
                    "right" : "0"
                });
            } else {
                // Center
                imageSelector.css({
                    "left" : Math.round(leftOffset) + "px",
                    "right" : "auto"
                });
            }

        } else {
    
            newWidth = containerWidth;
            newHeight = containerWidth / imageRatio;
            containerVertCenter = containerHeight / 2;
            imageVertCenter = newHeight / 2;
            topOffset = (imageVertCenter - containerVertCenter) * -1;

            // Grow it wider
            imageSelector.css({
                "width" : "100%",
                "height" : Math.round(newHeight) + "px",
                "left" : "0",
                "right" : "auto"
            });

            // Check which vertical side should be anchored (top, center, bottom)
            if (params["yPos"] == "top"){
                imageSelector.css({
                    "top" : "0",
                    "bottom" : "auto"
                });
            } else if (params["yPos"] == "bottom"){
                imageSelector.css({
                    "top" : "auto",
                    "bottom" : "0"
                });
            } else {
                // Center
                imageSelector.css({
                    "top" : Math.round(topOffset) + "px",
                    "bottom" : "auto"
                });
            }
            
        }
    };
})(jQuery);